export default {

  // Simplified Registration
  "register-page-title": "Online Registration",
  "register-page-subtitle": "Easily access your account information online.",
  "register-page-header-already-registered": "Already Registered? Sign In",
  "register-page-help-text": "**Need help registering?** Please call customer service for assistance: %brandPhone% ",
  "register-page-help-phone-further": "(800) 859-2144",
  "register-page-help-phone-vermont": "(866) 999-2605",
  "register-page-help-phone-kansas-city": "(800) 859-2144",
  "register-page-help-phone-carefirst": "(866) 758-6119",
  "register-page-help-phone-horizon": "(888) 215-0025",
  "register-page-help-phone-capital-bluecross": "(877) 293-7041",
  "register-page-help-phone-mhc": "(800) 859-2144",
  // Step 1
  "register-step-1-label": "Enter SA ID",
  "register-step-1-title": "Enter Your Spending Account ID",
  "register-step-1-subtitle": "To register for online access, we need to know your Spending Account ID number.",
  "register-step-1-SAID-label": "Spending Account ID",
  "register-step-1-SAID-error-required": "Enter your Spending Account ID (SA ID)",
  "register-step-1-info-widget-header": "What is my Spending Account ID?",
  "register-step-1-info-widget-paragraph-1": "Your Spending Account ID (SA ID) is the number on your Account Verification Form, which was mailed to you shortly after your account was opened.",
  "register-step-1-info-widget-paragraph-2": "If your Account Verification Form is lost or was never received, please call customer service to assist you in registering your account: %brandPhone%",
  "register-step-1-next-button-text": "Next",

  // Step 2
  "register-step-2-label": "Confirm Identity",
  "register-step-2-title": "Confirm your Identity",
  "register-step-2-subtitle": "Please confirm your identity by providing the requested information below.",
  "register-step-2-DOB-label": "Date of birth",
  "register-step-2-DOB-hint": "MM/DD/YYYY",
  "register-step-2-DOB-error-required": "Enter your date of birth",
  "register-step-2-DOB-error-invalid-date": "Invalid date",
  "register-step-2-DOB-error-future-date": "Date of birth must be a past date",
  "register-step-2-SSN-label": "Last 4 digits of SSN",
  "register-step-2-SSN-error": "Enter the last 4 digits of your SSN",
  "register-step-2-back-button-text": "Back",
  "register-step-2-next-button-text": "Next",
  "register-step-2-submitting-text": "Verifying Identity..",
  "register-step-2-error-text": "Unable to confirm the information entered. Please try again.",
  "register-step-2-captcha-text": "This form is protected by reCAPTCHA and the Google [Privacy Policy](https://policies.google.com/privacy) and [Terms of Service](https://policies.google.com/terms) apply.",

  // Step 3
  "register-step-3-label": "Create Profile",
  // Email
  "register-step-3-email-title": "Add Email",
  "register-step-3-email-subtitle": "We don't have an email address for you on file. Please add an email address so that you can receive important account notifications and updates.",
  "register-step-3-email-label": "Email",
  "register-step-3-email-error-required": "Enter your email address",
  "register-step-3-email-error-invalid": "Invalid email address format",
  "register-step-3-email-error-length": "Email cannot be longer than %maxLength% characters.",
  "register-step-3-email-next-button-text": "Next",
  "register-step-3-email-submitting-text": "Updating Email..",
  "register-step-3-email-error-text": "Unable to process the information at this time. Please try again.",
  // Credentials
  "register-step-3-credentials-title": "Create Your Online Profile",
  "register-step-3-credentials-subtitle": "Please create the username and password you will use to sign into your account.",
  "register-step-3-credentials-username-label": "Username",
  "register-step-3-credentials-username-rules-header": "Your username:",
  "register-step-3-credentials-username-rules-1": "Must be between 6–14 characters in length",
  "register-step-3-credentials-username-rules-2": "Can be a combination of letters, numbers, or symbols",
  "register-step-3-credentials-username-rules-3": "Can only include these symbols ^ $ * . [ ] { } ( ) ? - \" ! @ # % & / \ , > < ' ; | _ ~",
  "register-step-3-credentials-password-label": "Password",
  "register-step-3-credentials-password-rules-header": "Your password:",
  "register-step-3-credentials-password-rules-1": "Must be between 8–30 characters in length",
  "register-step-3-credentials-password-rules-2": "Must begin with a letter or number and contain at least one number",
  "register-step-3-credentials-password-rules-3": "Can only include these symbols ^ $ * . [ ] { } ( ) ? - \" ! @ # % & / \ , > < ' ; | _ ~",
  "register-step-3-credentials-password-rules-4": "Cannot use any letter, symbol or number more than twice in a row",
  "register-step-3-credentials-password-rules-6": "Must be different from previous passwords you have used",
  "register-step-3-credentials-password-rules-7": "Must not contain your username, first or last name",
  "register-step-3-credentials-terms-label": "I have read and agree to the <a href='%termsOfUseLink%' target='_blank'>Terms of Use</a> and <a href='%privacyPolicyLink%' target='_blank'>Privacy Policy</a>",
  "register-step-3-credentials-next-button-text": "Finish",
  "register-step-3-credentials-submitting-text": "Creating Profile..",
  "register-step-3-credentials-error-text": "Unable to process the information at this time. Please try again.",
  "register-step-3-credentials-error-duplicate-username-text": "The username requested is already in use.  Please try again.",
  "register-step-3-credentials-error-already-registered-text": "We show you are already a registered user on the Member Portal.",
  "register-step-3-credentials-error-fraudulent-text": "Your account is under review. Please contact Customer Support at %brandPhone% for more information.",
  "register-step-3-credentials-error-password-name": "Your password cannot contain your username, first or last name",
  "register-step-3-credentials-error-password-reused": "The password you entered has already been used. Please create a new password.",
  "register-step-3-credentials-error-password-age": "Your password cannot change more than once in 24 hours.",
  "register-step-3-credentials-success-text": "Your profile has been created successfully.",
};